const FEATURES = {
    MEMORY: { key: 'memory', expiresAt: new Date('2026-06-01T00:00:00Z') },
    // HORO-10360: shown from the moment it ships until 00:00 Pacific on 11/3 (PST — daylight saving
    // ends 11/1), the day the 28d report window first covers four full weeks after the 10/6 launch.
    BIRTH_CHART: {
        key: 'birthChart',
        expiresAt: new Date('2026-11-03T08:00:00Z')
    }
};

// `startsAt` is optional: a feature without one is new until it expires.
const isFeatureNew = (feature) => {
    const now = new Date();
    return (!feature.startsAt || now >= feature.startsAt) && now < feature.expiresAt;
};

export { FEATURES, isFeatureNew };
